import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-slider-style2',
  templateUrl: './slider-style2.component.html',
  styleUrls: ['./slider-style2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SliderStyle2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sliders/slider-style2/slider-style2.component.ts